import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ViewQuizzes = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const response = await axiosPrivate.get("/manager/quizzes");

        setSuccess(true);
        setQuizzes(response?.data?.quizzes);
      } catch (err) {
        console.error(err);
        setErrMsg(err?.response?.data?.message || err?.message);
      } finally {
        setLoading(false);
      }
    };
    fetchQuizzes();
  }, [axiosPrivate]);

  return (
    <div className="fade-in" style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager")}
      >
        ← Back to Dashboard
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          All Quizzes
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          View and manage all your created assessments
        </p>
      </div>

      {errMsg && <p className="errmsg">{errMsg}</p>}

      {loading ? (
        <div style={{ textAlign: "center", padding: "4rem" }}>
          <div className="spin" style={{ fontSize: "2rem", marginBottom: "1rem" }}>⏳</div>
          <p style={{ color: "var(--text-secondary)" }}>Loading quizzes...</p>
        </div>
      ) : (
        <>
          {success && quizzes.length > 0 ? (
            <div style={{ overflowX: "auto", borderRadius: "16px", border: "1px solid var(--border)" }}>
              <table style={{ width: "100%", minWidth: "800px" }}>
                <thead>
                  <tr>
                    <th>Quiz ID</th>
                    <th>Quiz Name</th>
                    <th>Quiz Type</th>
                    <th>Participants</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {quizzes.map((quiz) => (
                    <tr key={quiz.quizid}>
                      <td style={{ fontFamily: "monospace", fontSize: "0.875rem" }}>{quiz.quizid.substring(0, 8)}...</td>
                      <td style={{ fontWeight: "600", color: "var(--text-primary)" }}>{quiz.quizname}</td>
                      <td>
                        <span style={{
                          padding: "0.25rem 0.75rem",
                          borderRadius: "9999px",
                          fontSize: "0.875rem",
                          background: "rgba(124, 58, 237, 0.2)",
                          border: "1px solid var(--primary-purple)",
                          color: "var(--primary-purple-light)"
                        }}>
                          {quiz.quiztype}
                        </span>
                      </td>
                      <td>{quiz.numParticipants}</td>
                      <td>
                        <button
                          className="btn-primary"
                          style={{ fontSize: "0.875rem", padding: "0.5rem 1rem", minWidth: "auto" }}
                          onClick={() => {
                            localStorage.setItem("quizid", quiz.quizid);
                            navigate("/manager/quizdetails");
                          }}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="card" style={{ textAlign: "center", padding: "3rem" }}>
              <p style={{ color: "var(--text-muted)", marginBottom: "1rem" }}>No quizzes found.</p>
              <button className="btn-primary" onClick={() => navigate("/manager/createquiz")}>
                Create New Quiz
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ViewQuizzes;
